Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultAnalyticsProvider = exports.AnalyticsSourceContext = exports.AnalyticsContext = void 0;
var _react = require("react");
var DefaultAnalyticsProvider = exports.DefaultAnalyticsProvider = {
  trackEvent: function trackEvent() {}
};
var AnalyticsContext = exports.AnalyticsContext = (0, _react.createContext)(DefaultAnalyticsProvider);
var AnalyticsSourceContext = exports.AnalyticsSourceContext = (0, _react.createContext)({
  source: ''
});